<template>
  <div class="HeaderBar">
    <img :src="inseegoLogoSvg.src" alt="Inseego" class="logo">
    <slot></slot>
  </div>
</template>

<script setup>
import inseegoLogoSvg from '~/assets/inseego-logo.svg'
</script>

<style scoped>
.HeaderBar {
  padding-top: var(--spacing-6);
  padding-bottom: var(--spacing-6);
  padding-left: var(--wizard-gutter-width-left);
  padding-right: var(--wizard-gutter-width-right);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
